import { UserOutlined } from '@ant-design/icons'
import { Avatar, AvatarProps } from 'antd'
import React from 'react'

type Props = {
  pictureUrl?: string
  name?: string
  size?: number
  shape?: 'circle' | 'square'
  propsAvatar?: Partial<AvatarProps>
}

export const UserAvatar: React.FC<Props> = ({
  pictureUrl,
  name,
  size,
  shape = 'square',
  propsAvatar,
}) => {
  // Gradient style to apply when no picture URL is available
  const gradientStyle = {
    background: 'radial-gradient(circle at top left, #FF7F7F, #FFD77F)',
    color: 'white',
  }

  // Merge custom props with conditional gradient style
  const avatarStyle = !pictureUrl
    ? { ...gradientStyle, ...(propsAvatar?.style || {}) }
    : propsAvatar?.style || {}

  return (
    <Avatar
      size={size}
      shape={shape}
      src={pictureUrl}
      icon={!pictureUrl ? <UserOutlined /> : null}
      style={avatarStyle}
      {...propsAvatar}
    />
  )
}
